import { useSelector } from "react-redux";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import * as styled from "./Payment.styled";
import { LuCheckCircle, LuAlertCircle, LuAlertTriangle } from "react-icons/lu";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";

const lessonPackages = [
  {
  
    perLesson: "300",
    price: [
      {
        lessons: "8",

        discountedPrice: 2400,
        perLesson: 300,
      },
      {
        lessons: "16",
        originalPrice: 4800,
        discountedPrice: 4560,
        perLesson: 285,
      },
      {
        lessons: "32",
        originalPrice: 9600,
        discountedPrice: 8480,
        perLesson: 265,
      },
      {
        lessons: "50",
        originalPrice: 15000,
        discountedPrice: 12250,
        perLesson: 245,
      },
    ],
  }, 
  {
  
    perLesson: "350",
    price: [
      {
        lessons: "8",

        discountedPrice: 2800,
        perLesson: 350,
      },
      {
        lessons: "16",
        originalPrice: 5600,
        discountedPrice: 5360,
        perLesson: 335,
      },
      {
        lessons: "32",
        originalPrice: 11200,
        discountedPrice: 10080,
        perLesson: 315,
      },
      {
        lessons: "50",
        originalPrice: 17500,
        discountedPrice: 15000,
        perLesson: 300,
      },
    ],
  },
  {
  
    perLesson: "390",
    price: [
      {
        lessons: "8",

        discountedPrice: 3120,
        perLesson: 390,
      },
      {
        lessons: "16",
        originalPrice: 6240,
        discountedPrice: 6000,
        perLesson: 375,
      },
      {
        lessons: "32",
        originalPrice: 12480,
        discountedPrice: 11040,
        perLesson: 345,
      },
      {
        lessons: "50",
        originalPrice: 19500,
        discountedPrice: 16250,
        perLesson: 325,
      },
    ],
  }
];


// Картка пакета уроків: ціна, ціна за урок і скільки учень економить
function PackageCard({ pkg, isCurrent }) {
  const saving = pkg.originalPrice ? pkg.originalPrice - pkg.discountedPrice : 0;
  return (
    <styled.Package $current={isCurrent}>
      <styled.PackageTop>
        <styled.PackageHeader>{pkg.lessons} уроків</styled.PackageHeader>
        {isCurrent && <styled.CurrentBadge>Поточний</styled.CurrentBadge>}
      </styled.PackageTop>
      <styled.DiscountedPrice>{pkg.discountedPrice.toLocaleString("uk-UA")} грн</styled.DiscountedPrice>
      <styled.PerLessonPrice>{pkg.perLesson} грн за урок</styled.PerLessonPrice>
      {saving > 0 && (
        <styled.Saving>
          <styled.OriginalPrice>{pkg.originalPrice.toLocaleString("uk-UA")} грн</styled.OriginalPrice>
          економія {saving.toLocaleString("uk-UA")} грн
        </styled.Saving>
      )}
    </styled.Package>
  );
}

function Payment({isTrial}) {
  const { data } = useSelector((state) => state.auth);
  const total = Number(data.lessonPackage) || 0;
  const left = Number(data.totalLessons) || 0;
  const status = left <= 0 ? "empty" : left === 1 ? "low" : "ok";
  const StatusIcon = { empty: LuAlertCircle, low: LuAlertTriangle, ok: LuCheckCircle }[status];

  return (
    <PagesWrapper>
      <TopPageTitle value={!isTrial ? "Оплата" : "Ціни"} />
      <styled.Page>
      {!isTrial ? (
        <>
          <styled.Stats>
            <styled.Stat>
              <styled.StatLabel>Твій пакет</styled.StatLabel>
              <styled.StatValue>{total} <span>уроків</span></styled.StatValue>
            </styled.Stat>
            <styled.Stat>
              <styled.StatLabel>Залишилось уроків</styled.StatLabel>
              <styled.StatValue $status={status}>
                {left} <StatusIcon size={22} />
              </styled.StatValue>
              <styled.Progress>
                <styled.ProgressFill $status={status} style={{ width: `${total ? Math.min(100, (left / total) * 100) : 0}%` }} />
              </styled.Progress>
              {status !== "ok" && (
                <styled.StatHint $status={status}>
                  {status === "empty" ? "Уроки закінчились — час поповнити пакет" : "Залишився останній урок — час поповнити пакет"}
                </styled.StatHint>
              )}
            </styled.Stat>
          </styled.Stats>

          <styled.PackageTitle>Пакети уроків</styled.PackageTitle>
          <styled.OtherPackages>
            {lessonPackages
              .filter(({ perLesson }) => perLesson === data.lessonPrice)
              .flatMap(({ price }) => price)
              .map((pkg) => (
                <PackageCard key={pkg.lessons} pkg={pkg} isCurrent={data.lessonPackage === pkg.lessons} />
              ))}
          </styled.OtherPackages>
        </>
      ) : (
        <>
          <styled.PackageTitle>Можливі пакети уроків</styled.PackageTitle>
          <styled.OtherPackages>
            {lessonPackages
              .filter(({ perLesson }) => perLesson === "390")
              .flatMap(({ price }) => price)
              .map((pkg) => (
                <PackageCard key={pkg.lessons} pkg={pkg} isCurrent={false} />
              ))}
          </styled.OtherPackages>
        </>
      )}
      </styled.Page>
    </PagesWrapper>
  );
}

export default Payment;
